export class SetTemplateValid {
     answer: boolean;
}